import type { Lang } from "@/lib/types";

/** Public marketing locales in every environment; no launch flags. */
export const SITE_LOCALES = ["en", "sv", "no", "da", "de", "nl", "es", "fr", "pt", "it", "fi"] as const;
export const ALL_SITE_LOCALES = SITE_LOCALES;
export type SiteLocale = (typeof SITE_LOCALES)[number];
export const DEFAULT_LOCALE: SiteLocale = "en";

export function isSiteLocale(value: string): value is SiteLocale {
  return (SITE_LOCALES as readonly string[]).includes(value);
}
export function localePrefix(locale: SiteLocale): string {
  return locale === "en" ? "" : `/${locale}`;
}
export function toSiteLocale(lang: Lang): SiteLocale {
  return isSiteLocale(lang) ? lang : DEFAULT_LOCALE;
}
